import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import CircleButton from '@src/components/Buttons/CircleButton';

const ReportExportButtons = ({
  downloadMethods,
  pdfParams,
  onDownloadDocx,
  onDownloadExcel,
  preparingFile,
  setPreparingFile,
}) => {
  const intl = useIntl();

  const handleDownloadPdf = () => {
    setPreparingFile(true);
    downloadMethods.downloadPdf(pdfParams).finally(() => setPreparingFile(false));
  };

  const handlePrint = () => {
    setPreparingFile(true);
    downloadMethods.printPdf(pdfParams).finally(() => setPreparingFile(false));
  };

  return (
    <div className="gx-flex-row gx-align-items-center gx-guarnic-gap-2">
      <CircleButton
        onClick={handleDownloadPdf}
        iconName="picture_as_pdf"
        loading={preparingFile}
        tooltipText={intl.formatMessage({ id: 'general.download.pdf' })}
      />
      <CircleButton
        onClick={onDownloadDocx}
        iconName="description"
        tooltipText={intl.formatMessage({ id: 'general.download.docx' })}
      />
      <CircleButton
        onClick={onDownloadExcel}
        iconName="csv"
        tooltipText={intl.formatMessage({ id: 'general.download.excel' })}
      />
      <CircleButton
        onClick={handlePrint}
        iconName="print"
        loading={preparingFile}
        tooltipText={intl.formatMessage({ id: 'general.print' })}
      />
    </div>
  );
};

ReportExportButtons.propTypes = {
  downloadMethods: PropTypes.shape({
    downloadPdf: PropTypes.func.isRequired,
    printPdf: PropTypes.func.isRequired,
  }).isRequired,
  pdfParams: PropTypes.object.isRequired,
  onDownloadDocx: PropTypes.func.isRequired,
  onDownloadExcel: PropTypes.func.isRequired,
  preparingFile: PropTypes.bool.isRequired,
  setPreparingFile: PropTypes.func.isRequired,
};

export default ReportExportButtons;
